module.exports = __webpack_public_path__ + "img/map.e3cab925.svg";